module.exports = __webpack_public_path__ + "static/media/background-img-right.6862d4ba.svg";